import React from 'react';
import { Tag } from 'antd';

const DistanceTag = ({ distance, className }) =>
    !!distance && <Tag color='blue' className={className}>{(distance / 1000).toFixed(2)} км</Tag>;

export default DistanceTag;
